import { ReactComponent as PaymentsIcon } from "assets/icon/payments.svg";
import { compose, withHooks, withTranslation } from "enhancers";
import { TFunction } from "i18next";
import { AppColor } from "theme/app-color";
import { toCurrency } from "utils/helper";
import { Box, Divider, Hidden, Typography } from ".";

export interface CardData {
  id: string;
  tag: string;
  name: string;
  company?: string;
  amount?: number;
  refId?: string;
  onClick?: () => void;
  tagColor?: string;
  brokerName?: string;
  keyId?: string; // TODO: fix key naming
}

interface InfoCardProps {
  t: TFunction;
  data: CardData;
}

const InfoCardComponent = (props: InfoCardProps) => (
  <Box
    display="flex"
    flexDirection="column"
    style={{
      border: `1px solid ${AppColor["Primary/Primary"]}`,
      padding: "16px",
      borderRadius: "8px",
      backgroundColor: AppColor["Secondary  Light/Background"],
    }}
  >
    <Box
      style={{
        padding: "4px",
        borderRadius: "8px",
        backgroundColor: props.data.tagColor || AppColor["Primary/Primary"],
        width: "fit-content",
      }}
    >
      <Typography variant="Helper/12" color={AppColor["White / White"]}>
        {props.data.tag}
      </Typography>
    </Box>
    <Typography variant="Header/16" style={{ marginTop: "8px" }}>
      {props.data.name}
    </Typography>
    <Hidden when={props.data.company === undefined}>
      <Typography variant="Body/16" style={{ marginTop: "8px" }}>
        {props.data.company}
      </Typography>
    </Hidden>
    <Hidden when={props.data.brokerName === undefined}>
      <Typography variant="Body/16" style={{ marginTop: "8px" }}>
        {props.t(".broker")} {props.data.brokerName}
      </Typography>
    </Hidden>
    <Hidden when={props.data.keyId === undefined}>
      <Typography variant="Body/16" style={{ marginTop: "8px" }}>
        {props.data.keyId}
      </Typography>
    </Hidden>
    <Divider style={{ marginTop: "8px" }} />
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      style={{ marginTop: "8px", height: "20px" }}
    >
      <Box display="flex" alignItems="center" style={{ gap: "4px" }}>
        <Hidden when={props.data.amount === undefined}>
          <PaymentsIcon />
          <Typography variant="Caption/Bold">
            {props.t(".baht", { amount: toCurrency(props.data.amount) })}
          </Typography>
        </Hidden>
        <Hidden when={props.data.refId === undefined}>
          <Typography variant="Helper/12" color={AppColor["Text/Line"]}>
            {props.data.refId}
          </Typography>
        </Hidden>
      </Box>
      <Hidden when={props.data.onClick === undefined}>
        <Box
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          onClick={props.data.onClick}
          style={{
            cursor: "pointer",
            color: AppColor["Primary/Primary"],
            textDecoration: "underline",
          }}
        >
          <Typography variant="Helper/12">
            {props.t(".viewDetail")}
            {" >"}
          </Typography>
        </Box>
      </Hidden>
    </Box>
  </Box>
);

const enhancer = compose(
  withTranslation({ prefix: "components.common.InfoCard" }),
  withHooks((props: any, hooks: any) => {
    const { t, data } = props;

    return { t, data };
  })
);

export const InfoCard = enhancer(InfoCardComponent);
